import React, { useState } from 'react';
import './App.css';
import companyRoaster from './images/company_roaster.png';
import beanBags from './images/bean_bags.png';
import companyLogo from './images/company_logo.png';

function App() {
  const [showContactInfo, setShowContactInfo] = useState(false);

  const handleContactButtonClick = () => {
    setShowContactInfo(!showContactInfo);
  };

  const handleLinkClick = (url) => {
    const confirmLeave = window.confirm("You are about to leave this site. Do you want to continue?");
    if (confirmLeave) {
      window.location.href = url;
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert(`${text} has been copied to your clipboard!`);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };


  const handleSkipLinkClick = (e) => {
    e.preventDefault();
    const mainContent = document.querySelector('main'); 
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <div className="App">
      <header className="App-header" aria-label="Site header">
        <h1 tabIndex="0" aria-label="Company name: DCH ROASTERS, INC.">DCH ROASTERS, INC.</h1>
        <button 
          className="skip-link-button" 
          onClick={handleSkipLinkClick} 
          tabIndex="0"
          aria-controls="skip-link-button"
        >
          SKIP TO MAIN CONTENT
        </button>
        <button 
          className="contact-button" 
          onClick={handleContactButtonClick} 
          tabIndex="0"
          aria-expanded={showContactInfo}
          aria-controls="contact-info"
        >
          CONTACT US TO PLACE AN ORDER
        </button>
        {showContactInfo && (
          <div className="contact-info" id="contact-info" tabIndex="0" aria-label="contact-info-heading">
            <div>
              <strong>Phone:</strong> 
              <span style={{ marginLeft: '0.2rem' }}>
                <a 
                  href="tel:9519779199" 
                  style={{ color: 'white', textDecoration: 'underline' }} 
                  aria-label="Call 951-977-9199"
                >
                  951-977-9199
                </a>
              </span>
            </div>
            <div>
              <strong>Address:</strong> 
              <span style={{ marginLeft: '0.2rem' }}>
                <a 
                  tabIndex="0"
                  href="https://www.google.com/maps/dir//3772+Roosevelt+St,+Riverside,+CA+92503" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleLinkClick('https://www.google.com/maps/dir//3772+Roosevelt+St,+Riverside,+CA+92503');
                  }} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ color: 'white', textDecoration: 'underline' }} 
                  aria-label="Link to Google Maps for 3772 Roosevelt St, Riverside, CA 92503"
                >
                  3772 Roosevelt St, Riverside, CA 92503
                </a>
              </span>
            </div>
            <div>
              <strong>Fax:</strong> 
              <span style={{ marginLeft: '0.2rem' }}>
                <span 
                  tabIndex="0" 
                  aria-label="Fax number: 951-977-9198"
                  onClick={() => copyToClipboard('951-977-9198')} 
                  style={{ cursor: 'pointer', textDecoration: 'underline', color: 'white' }}
                >
                  951-977-9198
                </span>
              </span>
            </div>
            <div>
              <strong>Email:</strong> 
              <span style={{ marginLeft: '0.2rem' }}>
                <a 
                  tabIndex="0"
                  href="mailto:admin@dchroasters.com" 
                  style={{ color: 'white', textDecoration: 'underline' }} 
                  aria-label="Email: admin@dchroasters.com"
                  onClick={(e) => {
                    e.preventDefault();
                    copyToClipboard('admin@dchroasters.com');
                  }}
                >
                  admin@dchroasters.com
                </a>
              </span>
            </div>
          </div>
        )}
      </header>

  <main id="main-content" role="main" aria-label="Main content" tabIndex="-1">
        <div className="shop_description_container"> 
          <h2 className="company-description" tabIndex="0" aria-label="Company description: A local, family owned business, offering premium coffee, expert roasting, and dedicated support, for over 20 years.">
            A LOCAL, FAMILY OWNED BUSINESS, OFFERING: PREMIUM COFFEE, EXPERT ROASTING, AND DEDICATED SUPPORT, FOR OVER 20 YEARS.
          </h2>
        </div>

        <div className="media">
          <img 
            src={companyRoaster} 
            alt="DCH Coffee Roaster: roasted beans in drum" 
            tabIndex="0" 
            className="company-roaster-image"
          />
          <img 
            src={beanBags} 
            alt="3, 1 pound DCH coffee bags: decaf, house blend, and espresso" 
            tabIndex="0" 
            aria-label="Company Coffee Bean Bags" 
            className="bean-bags-image"
          />
        </div>
       <div className="text_middle">
          <h3 className="company-slogan" tabIndex="0" aria-label="Company slogan: Roasted weekly, ground hourly, loved daily.">
            <div>ROASTED WEEKLY,</div>
            <div>GROUND HOURLY,</div>
            <div>LOVED DAILY.</div>
          </h3>
        </div>

        <div className="company-logo-container"> 
          <img 
            src={companyLogo} 
            alt="DCH Logo" 
            className="company-logo" 
            tabIndex="0" 
          />
        </div>
    </main>

  <footer className="App-footer" role="contentinfo" aria-label="Site footer">
    <button 
      onClick={() => handleLinkClick("https://docs.google.com/document/d/1kC_4dL2yCbmolk8Rkc5_LowEj7-f8JHJKGFi5LdPnaY/edit?tab=t.0", "_blank")} 
        aria-label="Link to DCH Accessibility Statement"
        style={{ 
        color: 'white', 
        background: 'none', 
        border: 'none', 
        textDecoration: 'underline', 
        cursor: 'pointer', 
        padding: 0, 
        fontSize: 'inherit' 
      }} 
      tabIndex="0"
   >
      DCH ACCESSIBILITY STATEMENT
    </button>
  </footer> 
  </div> // end of app 
  );
}

export default App;

